import { Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { TipoProductoEnum } from 'src/app/global/enums/tipo-producto.enum';
import { DatosComercio } from 'src/app/global/interfaces/datos-comercio';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { GoogleResult } from 'src/app/global/interfaces/google-result';
import { ActividadesEconomicasDisponible, IdentificacionComercioResponse } from 'src/app/global/interfaces/identificacion-comercio-response';
import { Comuna, Localizacion } from 'src/app/global/interfaces/localizacion';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { SessionService } from 'src/app/global/services/session.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { SinActividadComponent } from 'src/app/main/dialogs/full-screem/sin-inicio/sin-actividad.component';
import { datosComercio } from 'src/app/messages/step-2-messages';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DatosComercioServiceVM } from 'src/app/view-model/services/datos-comercio.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { vulgarFractionValidator } from 'src/app/view-model/validators/vulgarFraction.validator';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-datos-comercio',
  templateUrl: './datos-comercio.component.html',
  styleUrls: ['./datos-comercio.component.scss']
})
export class DatosComercioComponent implements OnInit {
  @ViewChild(MatExpansionPanel, { static: false }) matExpansion: MatExpansionPanel;
  public mensajeErrorDatosComercio = datosComercio;
  public bloqActandRubro = false;
  public showActividades = true;
  public showDescripcionNegocio = true;
  public rubroSeleccionadoMCC = true;
  public panelOpenState = false;
  public direccion: Object;
  public rubros: any;
  public bloquearRadios = false;
  carroCantSeleccionada: number;
  actEconomic = true;
  esComercioFormal = true;
  existePersonaNatural: boolean;
  personaNatural: any;
  existePersonaNaturalPrecarga: boolean;
  esUnoaUno: boolean;
  dialog2doPlano: boolean;
  descripcionCorrespondeAux: string = "";
  edicionText: boolean = false;


  get edicion(): boolean {
    return this.flujosPaso2Serv.datosComercio.edicion;
  }

  @Input() showCantidadCampos = true;

  precarga = false;
  identificacionComercio: IdentificacionComercioResponse = {
    actividadesEconomicasDisponibles: [],
    actividadEconomica: null,
    nombreFantasia: null,
    direccion: null,
    descripcionNegocio: null,
    razonSocial: null,
    esFormal: null
  };

  filtroActividadesEconomicasDisponibles: ActividadesEconomicasDisponible[] = [];
  filtroRubros: any[] = [];

  localizaciones: Localizacion[];

  regionSelected: Localizacion;

  created = false;

  loading = false;

  submitted = false;
  processing = false;
  private clickTimeout = null;

  @Input() showInfoMessage = false;

  get flujos() { return this.flujosPaso2Serv; }

  @Output() paso2Ok: EventEmitter<any> = new EventEmitter();

  public datosDeComercio = new FormGroup({

    inicioActividades: new FormControl('iniciaActividad', [Validators.required]),
    actividadesEconomicas: new FormControl('', [Validators.required]),
    categoriaComercio: new FormControl('', [Validators.required]),
    // categoriaRazon: new FormControl('', [Validators.required]),
    nombreFantasia: new FormControl('', [Validators.required, vulgarFractionValidator]),
    descripcion: new FormControl(''),
    direccionCompleta: new FormControl('', []),
    region: new FormControl('', [Validators.required]),
    comuna: new FormControl('', [Validators.required]),
    avenidaCallePasaje: new FormControl('', [Validators.required]),
    numeroCalle: new FormControl('', [Validators.required]),
    numeroLocal: new FormControl('', [Validators.nullValidator, vulgarFractionValidator])


  });
  contador: any = 1000;
  public filterCtrl: FormControl = new FormControl();
  public filterCtrlCategoria: FormControl = new FormControl();

  ngOnInit() {
    this.showDescripcionNegocio = false;
    this.esUnoaUno = false;
    this.existePersonaNaturalPrecarga = false;
    // this.carroService.changeValorCantidad$.subscribe(cantidad => {
    //   if (cantidad === 0) {
    //     this.carroCantSeleccionada = Number(this.carroService.products[0].cantidad);
    //   } else {
    //     this.carroCantSeleccionada = cantidad;
    //   }
    // });
    this.datosDeComercio.get('inicioActividades').valueChanges.subscribe((value) => {

    });
  }

  get calculaCantidadALlenar() {
    let cantidad = 0;
    if (this.actEconomic) {
      cantidad = 7;
      if (this.showDescripcionNegocio) {
        cantidad = 8;
      }
    } else {
      cantidad = 6;
      if (this.showDescripcionNegocio) {
        cantidad = 7;
      }
    }
    return cantidad;
  }

  maxLengthTextArea(max: number) {
    let value = String(this.datosDeComercio.get('descripcion').value);
    if (value === 'null' || value === 'undefined') {
      value = '';
    }
    this.datosDeComercio.get('descripcion').setValue(value.substr(0, max - 1));
  }

  formInvalid() {
    let invalid = false;
    if (this.showDescripcionNegocio) {
      invalid = this.datosDeComercio.invalid || (String(this.datosDeComercio.get('descripcion').value).length === 0 || this.datosDeComercio.get('descripcion').value === null);
    } else {
      invalid = this.datosDeComercio.invalid;
    }
    return invalid;
  }

  constructor(private datosComercioServ: DatosComercioServiceVM,
    private ngZone: NgZone,
    private carroService: CarroComprasService,
    private dialogService: DialogService,
    private productService: vmProductosService,
    private datosPersonalesService: DatosPersonalesService,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private tagM: TagManagerService,
    private flujosPaso2Serv: FlujosPaso2Service,
    private modalService: NgbModal,
    private sessionService: SessionService) { }

  init() {
    this.created = true;
    this.obtieneLocalizaciones();
    this.tagM.logEvent(GoogleTagManager.eventPageView().datosComercio());
  }

  validaEdicion(): Promise<GeneralResponse<boolean>> {
    return new Promise((resolve, reject) => {
      const fnSuccess = (edicion: GeneralResponse<boolean>) => {
        resolve(edicion);
      };

      const fnFailure = (error) => {
        reject(error);
      };

      this.datosPersonalesService.validaEdicion().subscribe(fnSuccess, fnFailure);
    });
  }

  findRegionCommuneInGoogleResult(googleResult: GoogleResult) {
    let foundRegion: Localizacion;
    let foundCommune: Comuna;
    googleResult.address_components.find(address => {
      const addressClean: string = this.removeDeDelRegion(address.short_name);
      let existeRegion = false;
      let existeComuna = false;
      this.localizaciones.forEach(localizacion => {
        const regionClean = this.removeDeDelRegion(localizacion.asString);
        if (addressClean.includes(regionClean) || regionClean.includes(addressClean)) {
          existeRegion = true;
          if (existeRegion) {
            foundRegion = localizacion;
            foundCommune = this.findComuna(localizacion, googleResult);
            if (foundCommune) {
              existeComuna = true;
            }
          }
        }
      });
      return existeRegion && existeComuna;
    });
    if (foundRegion) {
      const regionIndex = this.localizaciones.findIndex((l) => l.id === foundRegion.id);
      this.datosDeComercio.get('region').setValue(regionIndex);
      this.setRegion();
    }
    if (foundCommune) {
      this.datosDeComercio.get('comuna').setValue(foundCommune.id);
    }
  }

  findComuna(localizacion: Localizacion, googleResult: GoogleResult): Comuna {
    let existeComuna = false;
    let foundCommune: Comuna;
    googleResult.address_components.find(address => {
      const addressClean: string = this.removeDeDelRegion(address.short_name);
      localizacion.comunas.forEach(comuna => {
        const comunaClean = comuna.asString.toLocaleLowerCase();
        if (!existeComuna) {

          if ((addressClean.includes(comunaClean) || comunaClean.includes(addressClean)) && address.types[0] === 'administrative_area_level_3') {
            existeComuna = true;
            if (existeComuna) {
              foundCommune = comuna;
            }
          }
        }
      });
    });
    return foundCommune;
  }

  removeDeDelRegion(word: string): string {
    let finalWord = '';
    finalWord = word.toLocaleLowerCase().replace('de', '');
    finalWord = finalWord.toLocaleLowerCase().replace('del', '');
    finalWord = finalWord.toLocaleLowerCase().replace('los', '');
    finalWord = finalWord.toLocaleLowerCase().replace('región', '');
    finalWord = finalWord.toLocaleLowerCase().replace('region', '');
    return finalWord;
  }

  obtenerDireccion(lugar: GoogleResult) {
    this.findRegionCommuneInGoogleResult(lugar);
    this.direccion = lugar.formatted_address;
    this.datosDeComercio.get('numeroCalle').setValue(this.obtenerNumeroCalle(lugar));
    this.datosDeComercio.get('avenidaCallePasaje').setValue(this.obtenerCalle(lugar));
    this.datosDeComercio.get('direccionCompleta').setValue(this.direccion);
    this.ngZone.run(() => { });
  }

  obtenerDirElemento(lugar, elementoRef) {
    let resultado;

    for (let i = 0; i < lugar.address_components.length; i++) {
      const tipoDireccion = lugar.address_components[i].types[0];
      if (elementoRef[tipoDireccion]) {
        resultado = lugar.address_components[i][elementoRef[tipoDireccion]];
        return resultado;
      }
    }
    return;
  }

  obtenerNumeroCalle(lugar) {
    const elemento_ref = { street_number: 'short_name' },
      numeroCalle = this.obtenerDirElemento(lugar, elemento_ref);
    return numeroCalle;
  }

  obtenerCalle(lugar) {
    const elemento_ref = { route: 'long_name' },
      calle = this.obtenerDirElemento(lugar, elemento_ref);
    return calle;
  }

  obtieneLocalizaciones() {

    const fnSuccess = (resp: Localizacion[]) => {
      this.localizaciones = resp;
      this.setRegion();
      this.obtieneIdentificacionComercio();
    };

    const fnFailure = (error) => {
      this.tagM.logError('Paso 2', error.statusText, error.message);
    };

    this.datosComercioServ.obtieneLocalizaciones()
      .subscribe(fnSuccess, fnFailure);
  }

  functionNr1(): void {
    setTimeout(() => {
      this.obtieneIdentificacionComercio();
    }, 5000);
  }

  obtieneIdentificacionComercio() {

    const fnSuccess = async (resp: IdentificacionComercioResponse) => {
      if (_.get(resp, 'indicador', '') === 'PROCESO_SEGUNDO_PLANO') {
        this.dialogService.openEnSegundoProcesoDialog();
        this.dialog2doPlano = true;
        this.functionNr1();
        return false;
      }

      if (this.dialog2doPlano == true) {
        this.dialogService.closeProcesoSegundoPlanoDialog();
        this.dialog2doPlano = false;
      }


      if (String(_.get(resp, 'mensaje.contenido', '')).includes('El flujo de Comercios Formales sin Match de A/E activas o inexistente en el sistema no se ha definido')) {
        const data = {
          title: 'Lo sentimos, en este momento, la actividad económica que seleccionaste no puede realizar el proceso de contratación a través del sitio web',
          description: 'Llama al Contact center al <strong>600 638 6380</strong> o al <strong>+56 2 2661 2700</strong> dónde uno de nuestros ejecutivos te ayudará a contratar el producto o servicios que necesitas',
          actionButton: 'Salir',
          icon: null
        };
        this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe(() => {
          this.marketplaceRedirectService.redirectPortalPublico();
        });
      } else {
        this.identificacionComercio = resp;
        this.filtroActividadesEconomicasDisponibles = this.identificacionComercio.actividadesEconomicasDisponibles;
        if (!this.identificacionComercio.actividadEconomica) {
          this.identificacionComercio.actividadEconomica = null;
        }
        if (!this.identificacionComercio.nombreFantasia) {
          this.identificacionComercio.nombreFantasia = null;
        }
        if (!this.identificacionComercio.direccion) {
          this.identificacionComercio.direccion = null;
        }
        if (!this.identificacionComercio.descripcionNegocio) {
          this.identificacionComercio.descripcionNegocio = null;
        }
        this.poseePersonaNatural(this.identificacionComercio);
        this.esUnoaUno = this.validarActUnoaUno();
        this.esComercioFormal = this.identificacionComercio.esFormal;

        if (this.esComercioFormal) {
          this.datosDeComercio.get('inicioActividades').setValue('iniciaActividad');
        } else {
          console.warn('No tiene actividad');
          //($('#noActividadModal') as any).modal('show');
          this.abrirModalSinActividad();
          this.datosDeComercio.get('inicioActividades').setValue('noIniciaActividad');
          this.actEconomic = false;
          //return;
        }

        this.changeInicio();
        this.loadDataForm();
        if(!this.datosDeComercio.get('descripcion')){
          this.datosDeComercio.get('descripcion').setValue(this.identificacionComercio.descripcionNegocio);
        }

        this.datosDeComercio.get('nombreFantasia').setValue(this.identificacionComercio.nombreFantasia);
        // this.datosDeComercio.get('categoriaRazon').setValue(this.identificacionComercio.razonSocial);
        if (this.identificacionComercio.direccion) {
          this.datosDeComercio.get('numeroLocal').setValue(this.identificacionComercio.direccion.complemento === null ? '' : this.identificacionComercio.direccion.complemento);
          const regionIndex = this.localizaciones.findIndex((region) => {
            const comuna = region.comunas.find((comuna) => {
              if (this.identificacionComercio.direccion !== null) {
                return comuna.id === this.identificacionComercio.direccion.idComuna;
              } else {
                return '';
              }
            });
            return comuna;
          });
          this.datosDeComercio.get('region').setValue(regionIndex);
          this.setRegion();
          this.datosDeComercio.get('comuna').setValue(this.identificacionComercio.direccion.idComuna);
        }

        if (this.datosDeComercio.valid) {
          this.flujosPaso2Serv.datosComercio.ok = true;
          this.paso2Ok.emit();
        }
        this.flujosPaso2Serv.datosComercio.mostrar = true;
        this.flujosPaso2Serv.datosComercio.cargando = false;
      }



    };

    const fnFailure = (err) => {
      const error = err.error;
      this.tagM.logError('Paso 2', err.statusText, err.message);
      if (String(_.get(error, 'mensaje.contenido', '')).includes('El flujo de Comercios Formales sin Match de A/E activas o inexistente en el sistema no se ha definido')) {
        const data = {
          title: 'Lo sentimos, en este momento, la actividad económica que seleccionaste no puede realizar el proceso de contratación a través del sitio web',
          description: 'Llama al Contact center al <strong>600 638 6380</strong> o al <strong>+56 2 2661 2700</strong> dónde uno de nuestros ejecutivos te ayudará a contratar el producto o servicios que necesitas',
          actionButton: 'Salir',
          icon: null
        };
        this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe(() => {
          this.marketplaceRedirectService.redirectPortalPublico();
        });
      }
    };

    this.datosComercioServ.obtieneIdentificacionComercio()
      .subscribe(fnSuccess, fnFailure);
  }

  private loadDataForm() {
    if (this.identificacionComercio.actividadEconomica) {
      this.existePersonaNaturalPrecarga = this.poseePersonaNaturalActividad(this.identificacionComercio);
      this.precarga = true;
      // this.actEconomic = true;
      this.datosDeComercio.get('actividadesEconomicas').setValue(this.identificacionComercio.actividadEconomica.id);
      this.cambioActividad();
      if (this.identificacionComercio.actividadEconomica.relacion[0]) {
        this.datosDeComercio.get('categoriaComercio').setValue(this.identificacionComercio.actividadEconomica.relacion[0].id);
        this.selRubro();
      } else {
        this.datosDeComercio.get('categoriaComercio').setValue('');
      }
      this.datosDeComercio.get('avenidaCallePasaje').setValue(this.identificacionComercio.direccion.direccion);
      this.datosDeComercio.get('numeroCalle').setValue(this.identificacionComercio.direccion.numero);
      this.datosDeComercio.get('direccionCompleta').setValue(this.identificacionComercio.direccion.direccion + ' ' + this.identificacionComercio.direccion.numero);
    } else {
      this.precarga = false;
      this.datosDeComercio.get('inicioActividades').setValue('iniciaActividad');
      this.activeYes();
      if (this.identificacionComercio.actividadesEconomicasDisponibles.length === 1) {
        this.datosDeComercio.get('actividadesEconomicas').setValue(this.identificacionComercio.actividadesEconomicasDisponibles[0].id);
        this.cambioActividad();
        if (this.identificacionComercio.actividadesEconomicasDisponibles[0].relacion.length === 1) {
          this.datosDeComercio.get('categoriaComercio').setValue(this.identificacionComercio.actividadesEconomicasDisponibles[0].relacion[0].id);
          this.selRubro();
        }
      }
    }
  }

  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (e) {
      console.error('SELECCION PRODUCTO:', e);
    }
  }

  goToLogin(): void {
    location.href = environment.redirections.marketplace;
  }

  Continuar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.processing = true;
      let gevent = GoogleTagManager.eventInteracciones().categoriaDatosDeComercio().accionClick();
      this.tagM.logEvent(gevent.setEtiqueta("continuar").setIsPersonaNatural(true));
      this.clickTimeout = setTimeout(() => {
        this.guardaIdentificacionComercio();
      }, 100);
    }

  }

  async guardaIdentificacionComercio() {
    this.loading = true;
    const datosComercio: DatosComercio = {
      idCategoria: Number(this.datosDeComercio.get('categoriaComercio').value),
      idActividadEconomica: Number(this.datosDeComercio.get('actividadesEconomicas').value),
      // razonSocial: this.datosDeComercio.get('razonSocial').value,
      nombreFantasia: this.datosDeComercio.get('nombreFantasia').value,
      direccion: {
        direccion: this.datosDeComercio.get('avenidaCallePasaje').value,
        numero: this.datosDeComercio.get('numeroCalle').value,
        complemento: this.datosDeComercio.get('numeroLocal').value === '' ? null : this.datosDeComercio.get('numeroLocal').value,
        idComuna: Number(this.datosDeComercio.get('comuna').value)
      },
      aceptaComercioInformal: this.actEconomic ? true : false,
      descripcionNegocio: this.datosDeComercio.get('descripcion').value
    };


    const fnSuccess = async response => {
      this.registraSeleccionProducto();
      try {
        const _edicion = (await this.validaEdicion()).data;
        if (!_edicion) {
          this.flujosPaso2Serv.setEdicionFalse();
        }
      } catch (e) { }

      if (!this.flujosPaso2Serv.configuracionProducto.ok) {
        this.flujosPaso2Serv.datosComercio.ok = true;
        this.paso2Ok.emit();
      }
      this.bloquearRadios = true;
      this.submitted = true;
      this.matExpansion.close();
      this.loading = false;
      this.processing = false;
      this.tagM.logDL_inicioActividades(this.actEconomic);
    };

    const fnFailure = error => {
      this.tagM.logError('Paso 2', error.statusText, error.message);
      const errorMsj: string = _.get(error, 'error.mensaje.contenido');
      if (errorMsj === 'Las selecciones del Cliente no son compatibles para su contratación.') {
        const producto = this.carroService.getCurrentProduct();
        const dialogRef = this.dialogService.openProductoNoDisponible(producto.title);
        dialogRef.afterClosed().subscribe(resp => {
          this.loading = false;
          this.processing = false;
          return;
        });
      }
    };


    this.datosComercioServ.registraDatosComercio(datosComercio).subscribe(fnSuccess, fnFailure);

  }

  private validarRubroProhibido() {
    const producto = this.carroService.getCurrentProduct();
    if (producto.codigoProducto === 'ARRIENDO_SMARTPOS' || producto.codigoProducto === 'COBRO_QR' || producto.codigoProducto == 'ARRIENDO_LITE_POS') {
      if (this.showDescripcionNegocio && this.esUnoaUno) {
        const dialogRef = this.dialogService.openRubroProhibido11();
        dialogRef.afterClosed().subscribe(resp => {
          return;
        });
      } else if (this.showDescripcionNegocio && !this.esUnoaUno) {
        const dialogRef = this.dialogService.openRubroProhibidoNN();
        dialogRef.afterClosed().subscribe(resp => {
          return;
        });
      }
    }
  }

  abrirModalSinActividad() {
    this.modalService.open(SinActividadComponent, { centered: true, backdrop: 'static', keyboard: false });
  }


  setRegion() {
    // this.regionSelected = this.localizaciones.find((r) => r.codigo == this.datosDeComercio.get('region').value);
    this.regionSelected = this.localizaciones[Number(this.datosDeComercio.get('region').value)];
    this.regionSelected.comunas.sort((a, b) => a.asString.localeCompare(b.asString));
  }

  onKey(event): void {
    this.contador = 1000 - event.target.value.length;
  }

  changeInicio(): void {
    if (this.datosDeComercio.get('inicioActividades').value === 'iniciaActividad') {
      this.activeYes();
    } else {
      this.activeNo();
    }
  }

  activeYes(): void {
    this.actEconomic = true;
    this.showDescripcionNegocio = false;
    this.rubros = [];
    this.datosDeComercio.get('categoriaComercio').setValue('');
    this.datosDeComercio.get('actividadesEconomicas').setValue('');
    this.datosDeComercio.get('');
    this.carroService.changeCantidad(false);
  }

  activeNo(): void {
    this.actEconomic = false;
    if (this.existePersonaNatural) {
      this.rubros = this.personaNatural[0].relacion;
      this.datosDeComercio.get('categoriaComercio').setValue(67);
      this.datosDeComercio.get('actividadesEconomicas').setValue(-1);
      this.datosDeComercio.get('descripcion').setValue('');
      this.showDescripcionNegocio = false;
    } else {
      this.datosDeComercio.get('descripcion').setValue('');
      this.showDescripcionNegocio = false;
      this.rubros = [];
    }
  }


  cambioActividad() {
    // this.inicializaActividadesEconomicas();
    this.showDescripcionNegocio = false;
    this.rubros = this.obtenerRubros();
    const actividad = this.datosDeComercio.get('actividadesEconomicas').value;
    if (this.actEconomic && !this.precarga) {
      if ((this.rubros ? this.rubros : []).length === 0 && actividad !== '') {
        if (this.identificacionComercio.actividadesEconomicasDisponibles.length === 1 && this.identificacionComercio.actividadesEconomicasDisponibles[0].relacion.length === 0) {
          this.dialogService.openUnaActividadSinCategoria().afterClosed().subscribe(() => {
            this.marketplaceRedirectService.redirectPortalPublico();
          });
        } else {
          this.dialogService.openActividadSinCategoria().afterClosed().subscribe(() => {
            this.datosDeComercio.get('actividadesEconomicas').setValue('');
          });
        }
        return;
      }
    }
  }

  private obtenerRubros() {
    let resultado: any[] = null;

    for (let i = 0; i < this.identificacionComercio.actividadesEconomicasDisponibles.length; i++) {
      const tipoActividad = this.identificacionComercio.actividadesEconomicasDisponibles[i].id;
      if (this.datosDeComercio.get('actividadesEconomicas').value === tipoActividad) {
        resultado = this.identificacionComercio.actividadesEconomicasDisponibles[i].relacion;
        if (resultado.length === 1) {
          this.datosDeComercio.get('categoriaComercio').setValue(resultado[0].id);
          this.showDescripcionNegocio = this.requiereDescripcion(resultado[0]);
          this.selRubro();
        } else {
          this.datosDeComercio.get('categoriaComercio').setValue('');
        }
        return resultado;
      }
    }
    return;
  }

  selRubro() {
    let rubro;
    if (this.precarga && this.poseePersonaNaturalActividad(this.identificacionComercio)) {
      rubro = _.find(this.personaNatural[0].relacion, { id: this.datosDeComercio.get('categoriaComercio').value });
    } else {
      rubro = _.find(this.rubros, { id: this.datosDeComercio.get('categoriaComercio').value });
    }
    if (rubro === undefined) {
      return;
    }
    /* Se almacena rubro seleccionado en sessionService para recuperar valor durante flujo */
    this.sessionService.setRubroSeleccionado(rubro);
    console.log("Data Rubro Seleccionado", this.sessionService.getRubroSeleccionado());

    this.showDescripcionNegocio = this.requiereDescripcion(rubro);
    if (!this.actEconomic && rubro.id !== 67) {
      if (Number(this.carroService.products[0].cantidad) > 3) {
        this.carroService.changeCantidad(true);
        this.actualizarCarrito();
      } else {
        this.carroService.changeCantidad(true);
      }
    } else {
      this.carroService.changeCantidad(false);
    }
  }

  private poseePersonaNatural(data: IdentificacionComercioResponse): any {
    this.personaNatural = _.remove(data.actividadesEconomicasDisponibles, { id: -1 });
    if (this.personaNatural) {
      this.existePersonaNatural = true;
    } else {
      this.existePersonaNatural = false;
    }
  }

  private poseePersonaNaturalActividad(data: IdentificacionComercioResponse): boolean {
    if (data.actividadEconomica.id === -1) {
      return true;
    } else {
      return false;
    }
  }

  private actualizarCarrito() {
    const dialogRef = this.dialogService.openMaximoProductos();
    dialogRef.afterClosed().subscribe(resp => {
    });
  }


  private validarActUnoaUno(): boolean {
    if (this.identificacionComercio.actividadesEconomicasDisponibles.length === 1 && this.identificacionComercio.actividadesEconomicasDisponibles[0].relacion.length === 1) {
      this.datosDeComercio.get('actividadesEconomicas').setValue(this.identificacionComercio.actividadesEconomicasDisponibles[0].id);
      this.datosDeComercio.get('categoriaComercio').setValue(this.identificacionComercio.actividadesEconomicasDisponibles[0].relacion[0].id);
      this.showDescripcionNegocio = this.requiereDescripcion(this.identificacionComercio.actividadesEconomicasDisponibles[0].relacion[0]);
      return true;
    } else {
      return false;
    }
  }

  inicializaActividadesEconomicas() {
    this.filtroActividadesEconomicasDisponibles = this.identificacionComercio.actividadesEconomicasDisponibles;
  }
  filtrarActividadesEconomicasDisponibles(event) {
    this.inicializaActividadesEconomicas();
    const val = event.target.value;
    if (val && val.trim() != '') {
      this.filtroActividadesEconomicasDisponibles = this.filtroActividadesEconomicasDisponibles.filter((item) => {
        return (item.asString.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    }
  }

  inicializaCategorias() {
    this.filtroRubros = this.rubros;
  }
  filtrarCategorias(event) {
    this.inicializaCategorias();
    const val = event.target.value;
    if (val && val.trim() != '') {
      this.filtroRubros = this.filtroRubros.filter((item) => {
        return (item.asString.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    }
  }

  requiereDescripcion(rubro) {
    const producto = this.carroService.getCurrentProduct();
    console.log('mcc' + this.rubroSeleccionadoMCC);
    console.log(producto.tipoVenta);
    if (rubro.mcc != 'NO' && rubro.descripcionMCC !== undefined) {
      this.rubroSeleccionadoMCC = true;
    } else {
      this.rubroSeleccionadoMCC = false;
    }
    console.log('mcc' + this.rubroSeleccionadoMCC);
    if (rubro.requiereDescripcionNegocio || rubro.mcc == 'MCC' && rubro.descripcionMCC !== undefined) {
      this.datosDeComercio.get('descripcion').setValue(rubro.descripcionMCC);
      return true;
    }
    if (rubro.mcc == 'MCC_NO_PRESENCIAL' && rubro.descripcionMCC !== undefined && this.isWeb(producto)) {
      this.datosDeComercio.get('descripcion').setValue(rubro.descripcionMCC);
      return true;
    }
    return false;
  }

  onDescripcionChange(event: any): void {
    this.descripcionCorresponde(event.value);
    this.edicionText = !event.value;
  }

  descripcionCorresponde(corresponde: boolean) {
    console.log(corresponde);
    if (!corresponde) {
      if (this.datosDeComercio.get('descripcion').value !== "") {
        this.descripcionCorrespondeAux = this.datosDeComercio.get('descripcion').value;
      }
      this.datosDeComercio.get('descripcion').setValue("");
    }
    if (corresponde && this.descripcionCorrespondeAux !== "") {
      this.datosDeComercio.get('descripcion').setValue(this.descripcionCorrespondeAux);
    }
  }
  public abrirCobroAdicionalmodal(): void {
    console.log("entro openCobroAdicionalDialog ");
    const dialogRef = this.dialogService.openValoresMCCDialog();
    dialogRef.afterClosed().subscribe(resp => {
      console.log("Modal cerrado");
    });
  }

  isWeb(producto) {
    if (producto.tipoProducto === TipoProductoEnum.SERVICIO_WEB && producto.codigoProducto !== CodigoProductoEnum.COBRO_QR
      || producto.codigoProducto === CodigoProductoEnum.PACK_VENTA_MPOS_LP
      || producto.codigoProducto === CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA
      || producto.codigoProducto === CodigoProductoEnum.PACK_POS_MOVIL_LP) {
      return true;
    }
    return false;
  }
}


